module.exports = __webpack_public_path__ + "static/media/wmgr_flatscreen.aa513c60.png";